<template>
  <div>
    <div class="home">
      <van-nav-bar title="合作伙伴" left-text="返回" @click-left="onClickLeft" fixed/>
      <div class="navheight"></div>
      <div class="content">
        <div class="nongmu_cont">
          <div class="contentTie">
            <img src="../../assets/joinusimg/companylogo/minzheng.png" alt="">
            <div class="company">河南民正农牧股份有限公司</div>
          </div>
          <div class="labInfo">
            <span>生猪</span>
            <span>养殖</span>
            <span>销售</span>
          </div>
          <div class="companyInfo">
            <img src="https://zkjy.oss-cn-beijing.aliyuncs.com/zkjyh5/zhjyhz/partnerimg/minzheng/3.jpg" alt="">
            <div class="companyWord">&nbsp; &nbsp; &nbsp; &nbsp;河南民正农牧股份有限公司位于河南省洛阳市宜阳县，现为一家新三板上市公司，股票代码：832132 公司四周群岭环抱，空气清新，交通便利，周边无工矿企业，环境宁静，远离主要干线公路，形成自然的生态屏障。该企业是按现代企业制度组建的，以种猪销售为主兼商品猪养殖、销售，及生态农业种植的股份有限公司。<br/>&nbsp; &nbsp; &nbsp; &nbsp;公司始建于2003年8月，从27头母猪养殖起步，2007年公司化运营成立河南民正畜牧业养殖有限公司，2014年9月股份制改革河南民正农牧股份有限公司成立，2015年2月新三板上市。主营种猪、商品猪生产销售及有机林果、农产品无公害种植、技术服务为一体的大型农牧企业。公司的本着创新，发展，安全，效益的企业精神，通过不懈的努力，使民正公司从发展质量，经营效益，市场口碑都成为了行业的杰出典范！ 目前公司资本9150万股，新三板总市值7.8亿元，公司现有职工580余人，其中高级职称（高级畜牧师、高级兽医师）28人，博士生2人，研究生16人，本科98人，大中专178人，安排农民工258余人。管理层均有10年以上的管理经验，技术科研人员均有5年以上的研发工作经验。公司占地总面积1万余亩，建筑面积50余万平方米，基础母猪存栏20000余头，年出栏生猪50万头，其中种猪15万头。现已建成现代化养殖基地9座（含种公猪站），一期二期三期工程种猪基地采用高规格建设，养殖设备采用大量的国外先进高科技产品，已经于2016年3月竣工投产；三期工程精准扶贫养殖小区于2016年8月竣工投产；四期工程于2017年2月20日投产；五期工程于2017年9月份投产；六期育肥基地于2017年12月份投产；七期、八期于2018年2月份投产；九期、十期工程紧张施工中。</div>
            <img src="https://zkjy.oss-cn-beijing.aliyuncs.com/zkjyh5/zhjyhz/partnerimg/minzheng/1.jpg" alt="">
          </div>
        </div>
      </div>
      <div class='bottom'>
        <div class="title">经营范围</div>
        <div class="info">生猪养殖、销售</div>
      </div>
      <footer class="nongmu-footer">
        <dl>
          <dt><img src="https://zkjy.oss-cn-beijing.aliyuncs.com/zkjyh5/zhjyhz/partnerimg/wangzhi@3x.png" alt=""></dt>
          <dd><a href="http://www.hnmzmy.com/">http://www.hnmzmy.com/</a></dd>
        </dl>
        <dl>
          <dt><img src="https://zkjy.oss-cn-beijing.aliyuncs.com/zkjyh5/zhjyhz/partnerimg/dizhi@3x.png" alt=""></dt>
          <dd>河南省洛阳市宜阳县莲庄镇马回村</dd>
        </dl>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: 'partner',
  methods: {
    onClickLeft() {
      this.$router.back(-1)
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../../assets/style/partner.scss';

</style>
